import { Component, OnInit } from '@angular/core';
import { ReportTaggingService } from 'src/app/services/report-tagging.service';
import { ReportTag } from 'src/app/models/reportTag';
import { ToastrService } from 'ngx-toastr';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { SearchPackageService } from 'src/app/services/search-package.service';

@Component({
  selector: 'app-quick-filter',
  templateUrl: './quick-filter.component.html',
  styleUrls: ['./quick-filter.component.less']
})
export class QuickFilterComponent implements OnInit {
  public reportTags : ReportTag[];
  constructor( public toast: ToastrService,public taggingSrv : ReportTaggingService,public scrn : ScreeningService) { }

  ngOnInit() {
    this.taggingSrv.LoadReportTags().subscribe(rsp=>{
      this.reportTags = rsp;
  },(err:any) =>{
      this.toast.error('Error Loading report tags for filtering', 'Error Loading report tags.')
  })
  }
  filterByTag(tag: number){
    this.scrn.activeTag = tag;
    this.scrn.FetchScreeningsForTag(tag);
  }

}
